
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "Navigation",
  components: {},
})
export default class Navigation extends Vue {
  navTabs = [
    {
      label: "首页",
      children: [
        "/temp/home",
        "/pcm/home",
        "/pcm/homePage",
        "/pcm/company",
        "/pcm/allpolicy",
        "/detail/match",
        "/pcm/tax",
        "/pcm/verify",
        "/pcm/productSale",
        "/pcm/expendpolicy_a",
        "/pcm/expendpolicy_b",
        "/pcm/expendpolicy_c",
        "/pcm/expendpolicy_d",
        "/pcm/expendpolicy_e",
        "/pcm/expendpolicy_f",
        "/pcm/GHpolicy_a",
        "/pcm/GHpolicy_b",
        // '/pcm/company/detail',
        // '/pcm/keyword/detail',
      ],
      default: "/pcm/homePage",
      index: 0,
      img: require("@/assets/images/icon/nav01.png"),
    },
    {
      label: "政策库",
      children: ["/pcm/policy", "/detail/policy"],
      default: "/pcm/policy",
      index: 1,
      img: require("@/assets/images/icon/nav02.png"),
    },
    // {
    //   label: "政策办理",
    //   children: ["/pcm/apply", "/detail/apply", "/detail/declare"],
    //   default: "/pcm/apply",
    //   index: 2,
    //   img: require("@/assets/images/icon/nav03.png"),
    // },
    {
      label: "政策大讲堂",
      children: ["/pcm/media", "/detail/img", "/detail/text"],
      default: "/pcm/media",
      index: 2,
      img: require("@/assets/images/icon/nav04.png"),
    },
    {
      label: "政策办理",
      children: [
        "/pcm/noApply",
        "/detail/noApply",
        // '/pcm/keyword/detail',
      ],
      default: "/pcm/noApply",
      index: 3,
      img: require("@/assets/images/icon/nav05.png"),
    },
    // {
    //   label: "申报通知",
    //   children: ["/pcm/inform", "/detail/inform"],
    //   default: "/pcm/inform",
    //   index: 3,
    // },

    {
      label: "公示公告",
      children: ["/pcm/publicy", "/detail/publicy"],
      default: "/pcm/publicy",
      index: 4,
      img: require("@/assets/images/icon/nav06.png"),
    },
    {
      label: "咨询建议",
      children: ["/pcm/appeal"],
      default: "/pcm/appeal",
      index: 5,
      img: require("@/assets/images/icon/nav07.png"),
    },
    /* {
        label: "企业诉求",
        children: ["/pcm/appeal"],
        default: "/pcm/appeal",
        index: 6,
      },
      {
        label: "服务超市",
        children: ["/pcm/market", "/detail/market"],
        default: "/pcm/market",
        index: 7,
      },*/

    // {
    //   label: '政策清单',
    //   children: ["/pcm/list"],
    //   default: '/pcm/list',
    //   index: 7,
    // },
  ];
  subTabs = [
    {
      name: "涉企动态",
      url: "/pcm/media",
    },
    // {
    //   name: "视频解读",
    //   url: "/pcm/media",
    // },
    {
      name: "文字解读",
      url: "/pcm/media",
    },
    {
      name: "图片解读",
      url: "/pcm/media",
    },
    // {
    //   name: "政策汇编",
    //   url: "https://book.yunzhan365.com/nqtou/yzvv/mobile/index.html",
    // },
    {
      name: "在线访谈",
      url: "/pcm/media",
    },
  ];
  subTabs1 = [
    // {
    //   name: "惠企兑现概要",
    //   url: "/pcm/noApply?index=0",
    // },
    {
      name: "政策项目",
      url: "/pcm/noApply?index=1", //菜单跳转地址与此无关
    },
    // {
    //   name: "无申请兑现",
    //   url: "/pcm/noApply?index=1",
    // },
    // {
    //   name: "政策申请",
    //   url: "/pcm/noApply?index=2",
    // },
    {
      name: "政策工具",
      url: "/pcm/noApply?index=3",
    },
  ];
  activeName = "0";
  handleClick(val: any) {
    const activeName = val;
    const currenName = this.$route.name;
    if (val.indexOf("-") == -1) {
      this.$router.push({ path: this.navTabs[activeName].default });
    } else {
      let currentRoute = val.split("-");
      this.$router.push({
        path: this.navTabs[currentRoute[0]].default,
        query: {
          index: currentRoute[1],
        },
      });
    }
  }
  created() {
    this.fixTab();
  }
  fixTab() {
    const currentRouter = this.$route.path;
    const currentActive: any = this.navTabs.find(
      (item: any) =>
        item.children.includes(currentRouter) ||
        item.children.some((route: any) => currentRouter.indexOf(route) !== -1)
    );
    if (currentActive) {
      this.activeName = String(currentActive.index);
    }
  }
  clickSub(item: any, index: any) {
    if (item.name == "政策汇编") {
      window.open(item.url);
    } else {
      this.$router.push({
        path: item.url,
        query: {
          index,
        },
      });
    }
  }
  @Watch(`$route`)
  routechange(to: any, from: any) {
    this.fixTab();
  }
}
